import script from "./GroupUpdateDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupUpdateDialog.vue?vue&type=script&lang=ts&setup=true"

import "./GroupUpdateDialog.vue?vue&type=style&index=0&id=734fc314&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734fc314"]])

export default __exports__